import React from "react";
import { useIntl } from "react-intl";

const FilterWrapper = ({
  message = "",
  FilterForm,
  filterFormProps,
  children,
}) => {
  const { formatMessage } = useIntl();

  return (
    <div className="py-5 gutter-b bg-white rounded bg-dark border bgi-no-repeat bg-primary">
      <div className="container d-flex flex-column">
        <div className="d-flex align-items-sm-end -flex-column -flex-sm-row mb-5">
          <h2 className="d-flex align-items-center mr-5 mb-0">
            {message && formatMessage(message)}
          </h2>
          <div className="ml-auto">{children}</div>
        </div>
        {<FilterForm {...filterFormProps} />}
      </div>
    </div>
  );
};

export default FilterWrapper;
